
// src/web/components/time-picker-dialog.jsx

import React from 'react'
import {
  Dialog,
} from 'react-toolbox/lib/dialog'
import Input from 'react-toolbox/lib/input'
import _ from 'lodash'
import timePickerTheme from './themes/time-picker-dialog.css'

class TimePickerDialog extends React.PureComponent {
  constructor(props) {
    super(props)

    const time = props.value && props.value.split && props.value.split(':') || ['00', '00']
    this.state = { hour: time[0], min: time[1] }
  }

  UNSAFE_componentWillUpdate(nextProps) {
    if (this.props.value != nextProps.value) {
      const time = nextProps.value && nextProps.value.split && nextProps.value.split(':') || ['00', '00']
      this.setState({ hour: time[0], min: time[1] })
    }
  }

  handleHour = (value)=> {
    value = parseInt(value)
    if (value < 24 && value >= 0)
      this.setState({ hour: ('0' + value).slice(value.toString().length - 1) })
  }

  handleMin = (value)=> {
    value = parseInt(value)
    if (value < 60 && value >= 0)
      this.setState({ min: ('0' + value).slice(value.toString().length - 1) })
  }

  onSelect = ()=> {
    this.props.onSelect && this.props.onSelect(`${this.state.hour}:${this.state.min}`)
  }

  render() {
    const {
      t,
      value,
      active,
      onSelect,
      onCancel,
      okLabel,
      cancelLabel,
    } = this.props
  
    return (
      <Dialog active={active}
        onEscKeyDown={onCancel}
        onOverlayClick={onCancel}
        actions={[
          { label: cancelLabel, onClick: onCancel },
          { label: okLabel, onClick: this.onSelect },
        ]} >
        <div className={timePickerTheme.wrapper}>
          <Input autoFocus type='number' step={1} value={this.state.hour} onChange={this.handleHour} className={timePickerTheme.input} />
          :
          <Input  type='number' step={1} value={this.state.min} onChange={this.handleMin} className={timePickerTheme.input} />
        </div>
      </Dialog>
    )
  }
}

export default TimePickerDialog



// WEBPACK FOOTER //
// ./src/web/components/time-picker-dialog.jsx